import React from "react";

// FloorToolbar: renders a button for each floor, highlights the selected one
const FloorToolbar = ({ floors, selectedFloorId, onSelectFloor }) => {
  return (
    <div className="floor-toolbar">
      {floors.map((floor) => (
        <button
          key={floor.id}
          className={
            "floor-toolbar-btn" + (selectedFloorId === floor.id ? " selected" : "")
          }
          onClick={() => onSelectFloor(floor.id)}
        >
          {floor.label}
        </button>
      ))}
    </div>
  );
};

export default FloorToolbar;
